export enum ApiTags {
    RegistrationFormData = 'RegistrationFormData',
    Registration = 'Registration',
    StartingList = 'StartingList',
}
